(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BridgeSimpleAddController', BridgeSimpleAddController);

    BridgeSimpleAddController.$inject = ['$scope', '$uibModalInstance', '$q', '$filter', '$translate', 'BridgeService', 'OltService', 'OnuService', 'onuItem'];
    function BridgeSimpleAddController($scope, $uibModalInstance, $q, $filter, $translate, BridgeService, OltService, OnuService, onuItem) {

        var vm = this;
        vm.requestRunning = false;

        // Comboboxes content
        vm.portList = [];
        vm.typesList = [];
        vm.multicastList = [];
        vm.rgModeList = [];

        // Comboboxes and radio buttons actions
        vm.setService = setService;
        vm.setMulticastList = setMulticastList;

        // Form actions
        vm.close = close;
        vm.save = save;
        vm.advancedSettings = advancedSettings;
        vm.setRgMode = setRgMode;

        // Return the path of the partial view
        vm.partial = partial;

        // Get validation rules
        var validationRules = BridgeService.getValidationRules();

        initialize();

        // Action Functions

        // Set the selected service
        function setService() {
            // Actions that are specific to each type
            if (vm.bridge.service == 'video') {
                // Enable the Multicast List combo
                setMcl();
                // Enable the maximum multicast streams input
                vm.bridge.maxMulticastStreams.disabled = false;
            } else {
                // Disable the IGMP Send IP input
                vm.bridge.multicastList.disabled = true;
                // Disable the maximum multicast streams input
                vm.bridge.maxMulticastStreams.disabled = true;
            }
        }

        // Set the selected multicast control list
        function setMulticastList(multicastList) {
            // Enable the maximum multicast streams input
            vm.bridge.maxMulticastStreams.disabled = false;
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        // Set the selected MCL
        function setMcl() {
            if (vm.bridge.service == 'video' && vm.bridge.olt.model.id && vm.multicastList.length) {
                vm.bridge.multicastList.disabled = false;
            } else {
                vm.bridge.multicastList.disabled = true;
            }
        }

        function initialize() {

            vm.bridge = {
                name: {value: '', maxlength: 60},
                interface: {value: 'ONU', disabled: true},
                olt: {model: {id: onuItem.oltId, name: onuItem.oltName}},
                port: {model: ''},
                onu: {model: {id: onuItem.onuId, name: onuItem.onuName}},
                type: {label: 'Downlink', value: 'DOWNLINK'},
                vlanMode: 'tagged',
                vlan: {value: ''},
                service: 'data',
                video: {disabled: false},
                voice: {disabled: true},
                multicastList: {model: '', disabled: true},
                maxMulticastStreams: {value: '', disabled: true},
                macLimit: '',
                rgMode: ''
            };

            disableSave();
            $q.all([
                getOltInfo(onuItem.oltId),
                getPortInfo(),
                getOnuInfo({oltId: onuItem.oltId, name: onuItem.onuName}),
                BridgeService.getTypes().then(setList('typesList')),
                BridgeService.getMulticastLists({oltId: onuItem.oltId}).then(setList('multicastList')),
            ]).then(function () {
                enableSave();
                getRgMode();
            }).catch(close);

        }

        function getRgMode() {
            var meProfile = vm.bridge.onu.model.meProfile;
            vm.bridge.rgMode = {model: {label: 'OMCI', value: ''}, disabled: false};

            if (vm.bridge.olt.model.model === 'Intelbras8820i') {
                if (meProfile === 'intelbras-110' || meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                    vm.bridge.rgMode.disabled = true;
                } else {
                    BridgeService.getRgModesIntelbras(meProfile).then(setList('rgModeList'));
                }
            } else {
                if (meProfile === 'intelbras-110' || meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                    vm.bridge.rgMode.disabled = true;
                } else {
                    BridgeService.getRgModesOLT8820G(meProfile).then(setList('rgModeList'));
                }
            }

        }

        // Set the RG Mode selected
        function setRgMode(rgMode) {
            advancedSettings();
        }

        function save() {

            if (vm.formAddBridge.$valid && !vm.requestRunning) {

                var data = {
                    name: vm.bridge.name.value.toUpperCase(),
                    oltId: vm.bridge.olt.model.id,
                    portNumber: vm.bridge.port.model.value,
                    portType: vm.bridge.port.model.type,
                    onuId: vm.bridge.onu.model.id,
                    type: vm.bridge.type.value,
                    vlanMode: vm.bridge.vlanMode.toUpperCase(),
                    vlan: vm.bridge.vlan.value,
                    serviceType: vm.bridge.service.toUpperCase()
                };

                if (vm.bridge.macLimit !== '' && vm.bridge.macLimit !== null) {
                    data.maxUnicast = vm.bridge.macLimit
                }

                if (vm.bridge.service == 'video') {
                    if (vm.bridge.multicastList.model.id) {
                        data.multicastControlListId = vm.bridge.multicastList.model.id;
                    }
                    data.maxMulticastStreams = vm.bridge.maxMulticastStreams.value;
                }

                if (vm.bridge.rgMode.model && vm.bridge.rgMode.model.value) {
                    data.rgMode = vm.bridge.rgMode.model.value
                }

                disableSave();
                BridgeService.addBridge(data).then(successAdd).catch(errorAdd);

            }
        }

        function advancedSettings() {
            var modalInstance = BridgeService.addBridgeModalConstructor(null, vm.bridge);
            modalInstance.result.finally(vm.close);
        }

        // Get OLT info to apply validation
        function getOltInfo(oltId) {
            return OltService
                    .getOlt(oltId)
                    .then(function (olt) {
                        vm.bridge.olt.model = olt;

                        // Apply validation rules and tooltip according to OLT model
                        angular.forEach(validationRules[olt.model], function (ruleValue, ruleName) {
                            if (vm.bridge[ruleName]) {
                                angular.forEach(ruleValue, function (value, key) {
                                    vm.bridge[ruleName][key] = value;
                                });
                                $translate('tooltip.' + ruleName, vm.bridge[ruleName]).then(setTooltip(ruleName));
                            }
                        });
                    });
        }

        function getPortInfo() {
            return BridgeService
                    .getPorts()
                    .then(function (data) {
                        vm.bridge.port.model = $filter('filter')(data['ONU'], {value: onuItem.gponPort})[0];
                    });
        }

        // Get onu info to enable/disable ONU Interface fields
        function getOnuInfo(data) {
            return OnuService
                    .getAuthorizedOnuList(data)
                    .then(function (onuList) {
                        vm.bridge.onu.model.meProfile = onuList[0].meProfile;
                    });
        }


        // Requests Callbacks
        function successAdd(data) {
            enableSave();
            BridgeService.successModalConstructor('add');
        }

        function errorAdd(response) {
            enableSave();
            BridgeService.errorModalConstructor(response, 'add');
        }

        // Utilities
        function disableSave() {
            vm.requestRunning = true;
        }

        function enableSave() {
            vm.requestRunning = false;
        }

        // Return a function that set the content of the defined list (used in comboboxes) when the promise is resolved
        function setList(list) {
            return function (data) {
                vm[list] = data;
            }
        }

        function partial(block) {
            return 'app/components/bridge/partials/bridge-config-' + block + '.html';
        }

        function setTooltip(input) {
            return function (translation) {
                vm.bridge[input].tooltip = translation;
            }
        }

    }
})();
